import React from 'react';
import { User, Membership } from '../types';
import { useLanguage } from '../i18n/LanguageContext';

interface ProfilePageProps {
  user: User | null;
  logout: () => void;
  login: (membership: Membership) => void;
}

const ProfilePage: React.FC<ProfilePageProps> = ({ user, logout, login }) => {
  const { t } = useLanguage();

  if (!user) {
    return (
      <div className="container mx-auto max-w-2xl text-center">
        <div className="bg-white/60 p-8 sm:p-12 rounded-4xl shadow-lg border border-white/50">
          <h2 className="text-2xl font-bold mb-4">{t('profilePage.title')}</h2>
          <p className="text-stone-600 mb-6">{t('profilePage.loginPrompt')}</p>
          <button
            onClick={() => login(Membership.Free)}
            className="inline-flex items-center justify-center px-8 py-3 text-base font-medium text-center text-white bg-accent rounded-full hover:bg-accent-dark focus:ring-4 focus:ring-accent/50"
          >
            {t('profilePage.login')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto max-w-2xl">
      <div className="bg-white/60 p-8 sm:p-12 rounded-4xl shadow-lg border border-white/50">
        <h1 className="text-4xl font-bold mb-4">{t('profilePage.greeting').replace('{name}', user.name)}</h1>
        <p className="text-lg text-stone-600 mb-8">
          {t('profilePage.membership')}
          <span className={`font-bold ml-2 ${user.membership === Membership.Premium ? 'text-accent' : 'text-stone-700'}`}>
            {user.membership}
          </span>
        </p>
        
        {user.membership === Membership.Free && (
          <div className="bg-accent/10 p-8 rounded-3xl text-center mb-8">
            <h2 className="text-2xl font-bold text-accent mb-3">{t('profilePage.unlockTitle')}</h2>
            <p className="text-stone-700 mb-6">{t('profilePage.unlockDesc')}</p>
            <button
                onClick={() => login(Membership.Premium)}
                className="inline-flex items-center justify-center px-8 py-3 text-base font-medium text-center text-white bg-accent rounded-full hover:bg-accent-dark focus:ring-4 focus:ring-accent/50"
            >
              {t('profilePage.upgradeNow')}
            </button>
          </div>
        )}

        <button
          onClick={logout}
          className="w-full text-center py-3 font-semibold text-red-600 bg-red-100 rounded-full hover:bg-red-200 transition-colors"
        >
          {t('profilePage.logout')}
        </button>
      </div>
    </div>
  );
};

export default ProfilePage;